import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  const translations = {
    es: {
      nav: {
        home: 'Inicio',
        services: 'Servicios',
        about: 'Sobre Nosotros',
        pricing: 'Precios',
        contact: 'Contacto',
      },
      hero: {
        subtitle: 'La Manga del Mar Menor · Cartagena · San Javier',
        title: 'Soluciones Informáticas a Domicilio y para Empresas',
        description: 'Servicio técnico informático profesional a domicilio con más de 20 años de experiencia y más de 5000 intervenciones realizadas. Reparación de PC, eliminación de virus, mantenimiento empresarial y cursos de inteligencia artificial. Disponible 24/7 en La Manga del Mar Menor, Cartagena y San Javier.',
        cta: 'Contactar por WhatsApp',
        phone: 'Llamar Ahora',
        available: 'Disponible 24/7',
        experience: 'años de experiencia',
        features: {
          fast: 'Servicio Rápido',
          fastDesc: 'Respuesta inmediata a domicilio en La Manga, Cartagena y San Javier',
          warranty: 'Garantía Total',
          warrantyDesc: 'Todos nuestros servicios incluyen garantía de satisfacción',
          professional: 'Profesional Certificado',
          professionalDesc: 'Más de 20 años de experiencia y 5000+ clientes satisfechos'
        },
        schedule: {
          title: 'Horarios de Atención',
          weekdays: 'Lunes - Viernes',
          weekdaysHours: '8:00 - 22:00',
          saturday: 'Sábado',
          saturdayHours: '9:00 - 20:00',
          sunday: 'Domingo',
          sundayHours: '10:00 - 18:00',
          emergency: 'Emergencias 24/7'
        }
      },
      services: {
        title: 'Nuestros Servicios',
        subtitle: 'Soluciones completas para todas tus necesidades informáticas en La Manga, Cartagena y San Javier',
        items: {
          repair: {
            title: 'Reparación de PC y Portátiles',
            description: 'Diagnóstico y solución de problemas de hardware y software a domicilio en La Manga del Mar Menor.'
          },
          virus: {
            title: 'Eliminación de Virus',
            description: 'Limpieza completa de malware, virus y protección de tu sistema en Cartagena.'
          },
          maintenance: {
            title: 'Mantenimiento Empresas',
            description: 'Planes de mantenimiento preventivo y correctivo para empresas en San Javier.'
          },
          installation: {
            title: 'Instalación de Windows',
            description: 'Instalación y configuración profesional de sistemas operativos.'
          },
          courses: {
            title: 'Cursos de IA',
            description: 'Formación en inteligencia artificial para particulares y empresas en Murcia.'
          },
          support: {
            title: 'Recuperación de Datos',
            description: 'Servicios especializados de recuperación de datos perdidos.'
          }
        },
        cta: {
          title: '¿Necesitas ayuda con tu equipo?',
          description: 'Estamos disponibles 24/7 en La Manga, Cartagena y San Javier para resolver cualquier problema informático',
          button: 'Contactar Ahora'
        }
      },
      about: {
        title: 'Sobre BertoProduction',
        subtitle: 'Agencia Web e Informática 360°',
        description: 'BertoProduction es tu agencia web e informática de servicios a 360 grados en el mundo de la tecnología. Con más de 20 años de experiencia, ofrecemos soluciones completas que abarcan desde el mantenimiento de PC para empresas y particulares, hasta la creación de sitios web profesionales, gestión de redes sociales (Social Media Manager), implementación de inteligencia artificial y desarrollo de agentes autónomos. Nos especializamos en transformar la presencia digital de nuestros clientes, combinando servicios técnicos tradicionales con las últimas innovaciones en IA y automatización. Operamos principalmente en La Manga del Mar Menor, Cartagena y San Javier, brindando soporte 24/7 para garantizar que tu negocio nunca se detenga.',
        features: {
          experience: 'Años de Experiencia',
          availability: 'Disponibilidad',
          warranty: 'Satisfacción'
        },
        areas: {
          title: 'Zonas de Servicio',
          lamanga: 'La Manga',
          lamangatext: 'Mar Menor',
          cartagena: 'Cartagena',
          cartagenatext: 'Puerto',
          sanjavier: 'San Javier',
          sanjaviertext: 'Aeropuerto'
        }
      },
      pricing: {
        title: 'Planes y Precios',
        subtitle: 'Soluciones a medida para cada necesidad, desde reparaciones puntuales hasta soporte empresarial completo y formación en IA.',
        plans: {
          basic: {
            title: 'Soporte Esencial',
            price: 'Desde 40€',
            description: 'Ideal para reparaciones puntuales y problemas comunes.',
            features: [
              'Diagnóstico y reparación de hardware/software',
              'Eliminación de virus y malware',
              'Optimización del sistema',
              'Soporte remoto o a domicilio'
            ],
            buttonText: 'Solicitar Soporte'
          },
          business: {
            title: 'Mantenimiento Anual',
            price: 'Desde 300€/año',
            popular: 'Más Popular',
            description: 'Servicio integral para empresas que buscan tranquilidad y eficiencia.',
            features: [
              'Todo lo del plan Esencial',
              'Mantenimiento preventivo mensual',
              'Soporte prioritario 24/7',
              'Consultoría y seguridad informática'
            ],
            buttonText: 'Contratar Plan'
          },
          courses: {
            title: 'Cursos de IA',
            price: 'Desde 99€',
            description: 'Aprende a utilizar la IA para potenciar tu negocio o carrera.',
            features: [
              'Cursos personalizados y grupales',
              'Formación en herramientas de IA',
              'Aplicaciones prácticas para empresas',
              'Soporte post-curso'
            ],
            buttonText: 'Inscribirse Ahora'
          }
        }
      },
      contact: {
        title: 'Contacto',
        description: '¿Tienes alguna pregunta o necesitas asistencia? Contáctanos.',
        phone: 'Teléfono',
        whatsapp: 'WhatsApp',
        email: 'Email',
        form: {
          name: 'Nombre',
          email: 'Email',
          message: 'Mensaje',
          send: 'Enviar Mensaje',
          success: '¡Mensaje enviado con éxito!',
          error: 'Hubo un error al enviar el mensaje.'
        }
      },
      footer: {
        description: 'BertoProduction - Agencia web e informática especializada en soluciones digitales completas para empresas y particulares en La Manga del Mar Menor, Cartagena y San Javier.',
        servicesTitle: 'Servicios',
        linksTitle: 'Enlaces Rápidos',
        legalTitle: 'Legal',
        privacy: 'Política de Privacidad',
        cookies: 'Política de Cookies',
        rights: 'Todos los derechos reservados.',
      },
      cookies: {
        title: 'Uso de Cookies',
        description: 'Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para mejorar tu experiencia. Puedes personalizar tus preferencias en cualquier momento.',
        acceptAll: 'Aceptar Todo',
        rejectAll: 'Rechazar Todo',
        customize: 'Personalizar',
        readMore: 'Leer Política de Cookies',
        settings: {
          title: 'Configuración de Cookies',
          required: 'Requerido',
          save: 'Guardar Preferencias',
          necessary: {
            title: 'Cookies Necesarias',
            description: 'Esenciales para el funcionamiento básico del sitio web. No se pueden desactivar.'
          },
          analytics: {
            title: 'Cookies Analíticas',
            description: 'Nos ayudan a entender cómo los visitantes interactúan con el sitio web mediante la recopilación de información de forma anónima.'
          }
        }
      },
      cookieBanner: {
        message: 'Utilizamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestro uso de cookies.',
        accept: 'Aceptar',
      },
      privacy: {
        title: 'Política de Privacidad',
        lastUpdated: 'Última actualización: Enero 2024',
        intro: 'En BertoProduction, respetamos tu privacidad y nos comprometemos a proteger tus datos personales. Esta política explica cómo recopilamos, usamos y protegemos tu información.',
        controller: {
          title: 'Responsable del Tratamiento',
          company: 'Empresa:',
          nif: 'NIF:',
          address: 'Dirección:',
          email: 'Email:',
          phone: 'Teléfono:'
        },
        collection: {
          title: 'Datos que Recopilamos',
          intro: 'Recopilamos los siguientes datos cuando utilizas nuestros servicios:',
          items: {
            name: 'Nombre y apellidos',
            email: 'Dirección de correo electrónico',
            phone: 'Número de teléfono',
            service: 'Información sobre el servicio solicitado',
            message: 'Mensajes y comunicaciones'
          }
        },
        purpose: {
          title: 'Finalidad del Tratamiento',
          items: {
            respond: 'Responder a tus consultas y solicitudes de servicio',
            provide: 'Proporcionar los servicios contratados',
            improve: 'Mejorar nuestros servicios y experiencia de usuario',
            comply: 'Cumplir con obligaciones legales'
          }
        },
        legal: {
          title: 'Base Legal',
          description: 'El tratamiento de tus datos se basa en tu consentimiento y en la ejecución del contrato de servicios.'
        },
        retention: {
          title: 'Conservación de Datos',
          description: 'Conservaremos tus datos durante el tiempo necesario para cumplir con las finalidades descritas y las obligaciones legales aplicables.'
        },
        cookies: {
          title: 'Uso de Cookies',
          description: 'Utilizamos cookies para mejorar tu experiencia en nuestro sitio web:',
          necessary: {
            title: 'Cookies Necesarias',
            description: 'Esenciales para el funcionamiento del sitio web.'
          },
          analytics: {
            title: 'Cookies Analíticas (Google Analytics)',
            description: 'Nos ayudan a entender cómo los usuarios interactúan con nuestro sitio.'
          }
        },
        rights: {
          title: 'Tus Derechos',
          intro: 'Tienes derecho a:',
          items: {
            access: {
              title: 'Acceso:',
              description: 'Solicitar acceso a tus datos personales.'
            },
            rectification: {
              title: 'Rectificación:',
              description: 'Corregir datos inexactos o incompletos.'
            },
            erasure: {
              title: 'Supresión:',
              description: 'Solicitar la eliminación de tus datos.'
            },
            restriction: {
              title: 'Limitación:',
              description: 'Limitar el tratamiento de tus datos.'
            },
            portability: {
              title: 'Portabilidad:',
              description: 'Recibir tus datos en formato estructurado.'
            },
            objection: {
              title: 'Oposición:',
              description: 'Oponerte al tratamiento de tus datos.'
            }
          },
          exercise: 'Para ejercer estos derechos, contáctanos a través de los medios proporcionados.'
        },
        security: {
          title: 'Seguridad',
          description: 'Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos contra acceso no autorizado, pérdida o destrucción.'
        },
        contact: {
          title: 'Contacto',
          description: 'Si tienes preguntas sobre esta política de privacidad, contáctanos:',
          email: 'Enviar Email',
          phone: 'Llamar'
        }
      },
      articlesBanner: {
        title: 'Artículos de Interés',
        subtitle: 'Descubre más sobre nuestros servicios especializados y cómo podemos ayudarte.',
        readMore: 'Leer más',
        articles: {
          repair: {
            title: 'Guía Completa de Reparación de PC',
            description: 'Aprende sobre los problemas más comunes y nuestras soluciones.'
          },
          virus: {
            title: 'Cómo Eliminar Virus y Proteger tu Equipo',
            description: 'Consejos y servicios para mantener tu PC seguro.'
          },
          maintenance: {
            title: 'Mantenimiento Informático para Empresas',
            description: 'La importancia de un plan preventivo para tu negocio.'
          },
          courses: {
            title: 'Iníciate en la Inteligencia Artificial',
            description: 'Descubre nuestros cursos y cómo la IA puede transformar tu trabajo.'
          }
        }
      },
      articles: {
        readTime: '5 min de lectura',
        updated: 'Actualizado 2024',
        cta: {
          urgent: '¿Necesitas ayuda urgente?',
          available: 'Disponible 24/7',
          call: 'Llamar',
          virus: '¿Virus en tu PC?',
          immediate: 'Asistencia inmediata',
          business: 'Mantenimiento Empresarial',
          plans: 'Planes personalizados',
          courses: 'Cursos de IA',
          learn: 'Aprende ahora'
        },
        repair: {
          category: 'Reparación PC',
          title: 'Reparación de PC La Manga del Mar Menor',
          subtitle: 'Servicio profesional de reparación de PC y portátiles en La Manga del Mar Menor.',
          intro: {
            title: 'Diagnóstico y Solución Rápida para tu Ordenador',
            p1: 'Un ordenador lento o averiado puede ser un gran inconveniente. Ofrecemos un servicio de reparación rápido y eficaz en La Manga del Mar Menor para que recuperes tu productividad lo antes posible.',
            p2: 'Con más de 20 años de experiencia, diagnosticamos y solucionamos desde los problemas más simples hasta los más complejos.'
          },
          problems: {
            title: 'Problemas Comunes que Solucionamos',
            problem1: {
              title: 'El ordenador no enciende',
              description: 'Problemas con la fuente de alimentación, placa base o componentes internos.'
            },
            problem2: {
              title: 'Sistema lento',
              description: 'Optimización del sistema operativo, limpieza de malware y mejora del rendimiento.'
            },
            problem3: {
              title: 'Pantallazos azules',
              description: 'Diagnóstico de errores críticos del sistema y solución de conflictos de hardware.'
            },
            problem4: {
              title: 'Sobrecalentamiento',
              description: 'Limpieza de ventiladores, cambio de pasta térmica y mejora de la refrigeración.'
            },
            problem5: {
              title: 'Fallos de hardware',
              description: 'Sustitución de discos duros, memoria RAM, tarjetas gráficas y otros componentes.'
            }
          },
          process: {
            title: 'Nuestro Proceso de Reparación',
            step1: {
              title: 'Contacto Inicial',
              description: 'Nos contactas por WhatsApp o teléfono y nos explicas tu problema.'
            },
            step2: {
              title: 'Diagnóstico',
              description: 'Realizamos un diagnóstico completo para identificar la causa del fallo.'
            },
            step3: {
              title: 'Presupuesto',
              description: 'Te ofrecemos un presupuesto cerrado y sin compromiso.'
            },
            step4: {
              title: 'Reparación',
              description: 'Procedemos con la reparación usando componentes de calidad.'
            }
          },
          why: {
            title: '¿Por qué elegirnos?',
            reason1: 'Más de 20 años de experiencia en reparación de PC',
            reason2: 'Servicio a domicilio en La Manga del Mar Menor',
            reason3: 'Presupuesto sin compromiso',
            reason4: 'Garantía en todas nuestras reparaciones'
          },
          finalCta: {
            title: '¿Tu ordenador necesita ayuda?',
            description: 'Contáctanos ahora y obtén una solución rápida y profesional.',
            whatsapp: 'Contactar por WhatsApp',
            contact: 'Ver Precios'
          }
        },
        virus: {
          category: 'Eliminación de Virus',
          title: 'Eliminación de Virus Cartagena',
          subtitle: 'Servicio experto de eliminación de virus y malware en Cartagena.',
          intro: {
            title: 'Recupera la Seguridad y Velocidad de tu Equipo',
            p1: 'Los virus y el malware no solo ralentizan tu ordenador, sino que también ponen en riesgo tu información personal.',
            p2: 'Nuestro servicio de eliminación de virus en Cartagena está diseñado para limpiar a fondo tu sistema y protegerte contra futuras amenazas.'
          },
          signs: {
            title: 'Señales de que tu PC podría estar infectado',
            sign1: 'Lentitud extrema y bloqueos inesperados',
            sign2: 'Aparición de ventanas emergentes no deseadas',
            sign3: 'Programas que se inician solos',
            sign4: 'Redirecciones a páginas web desconocidas',
            sign5: 'Mensajes de antivirus falsos',
            sign6: 'Archivos que desaparecen o no se pueden abrir'
          },
          types: {
            title: 'Tipos de Amenazas que Eliminamos',
            type1: {
              title: 'Virus y Troyanos',
              description: 'Programas maliciosos que se replican y dañan el sistema.'
            },
            type2: {
              title: 'Ransomware',
              description: 'Malware que cifra tus archivos y pide rescate.'
            },
            type3: {
              title: 'Spyware',
              description: 'Software espía que roba tu información personal.'
            },
            type4: {
              title: 'Adware',
              description: 'Publicidad no deseada que ralentiza tu navegador.'
            },
            type5: {
              title: 'Rootkits',
              description: 'Amenazas ocultas difíciles de detectar.'
            }
          },
          service: {
            title: 'Nuestro Método de Limpieza',
            step1: {
              title: 'Análisis Profundo',
              description: 'Escaneamos todo el sistema en busca de amenazas.'
            },
            step2: {
              title: 'Eliminación Segura',
              description: 'Removemos todo el malware sin dañar tus archivos.'
            },
            step3: {
              title: 'Optimización',
              description: 'Optimizamos el rendimiento y actualizamos la seguridad.'
            },
            step4: {
              title: 'Protección',
              description: 'Instalamos y configuramos protección antivirus.'
            }
          },
          prevention: {
            title: 'Consejos de Prevención',
            tip1: 'Mantén tu antivirus actualizado',
            tip2: 'No abras correos de remitentes desconocidos',
            tip3: 'Descarga software solo de fuentes oficiales',
            tip4: 'Realiza copias de seguridad regularmente',
            tip5: 'Mantén tu sistema operativo actualizado'
          },
          finalCta: {
            title: '¿Sospechas que tienes un virus?',
            description: 'Actúa ahora antes de que sea tarde. Protege tu información.',
            whatsapp: 'Limpiar mi PC Ahora',
            contact: 'Más Información'
          }
        },
        maintenance: {
          category: 'Mantenimiento Empresarial',
          title: 'Mantenimiento Informático San Javier',
          subtitle: 'Servicio de mantenimiento para empresas en San Javier.',
          intro: {
            title: 'La Tranquilidad de un Sistema Informático Fiable',
            p1: 'En un entorno empresarial, cualquier fallo informático puede suponer pérdidas de tiempo y dinero.',
            p2: 'Nuestro servicio de mantenimiento está diseñado para prevenir problemas antes de que ocurran.'
          },
          benefits: {
            title: 'Beneficios del Mantenimiento',
            benefit1: {
              title: 'Reducción de averías',
              description: 'Menos tiempo de inactividad y mayor productividad.'
            },
            benefit2: {
              title: 'Mejor rendimiento',
              description: 'Equipos optimizados y actualizados.'
            },
            benefit3: {
              title: 'Soporte prioritario',
              description: 'Respuesta rápida ante cualquier incidencia.'
            },
            benefit4: {
              title: 'Seguridad reforzada',
              description: 'Protección contra ciberataques y pérdida de datos.'
            },
            benefit5: {
              title: 'Asesoramiento',
              description: 'Consultoría tecnológica para optimizar recursos.'
            },
            benefit6: {
              title: 'Costes predecibles',
              description: 'Plan anual con precio fijo.'
            }
          },
          services: {
            title: 'Servicios Incluidos',
            service1: {
              title: 'Auditoría Inicial',
              description: 'Evaluamos el estado de tu infraestructura informática.',
              item1: 'Análisis de equipos y red',
              item2: 'Identificación de vulnerabilidades',
              item3: 'Plan de mejora personalizado'
            },
            service2: {
              title: 'Mantenimiento Preventivo',
              description: 'Revisiones periódicas para optimizar el sistema.',
              item1: 'Limpieza de hardware',
              item2: 'Actualizaciones de software',
              item3: 'Optimización del rendimiento'
            },
            service3: {
              title: 'Soporte Técnico',
              description: 'Asistencia remota y telefónica.',
              item1: 'Resolución de incidencias',
              item2: 'Asesoramiento técnico',
              item3: 'Disponibilidad 24/7'
            },
            service4: {
              title: 'Copias de Seguridad',
              description: 'Protección de datos con backups automatizados.',
              item1: 'Backups diarios automáticos',
              item2: 'Almacenamiento seguro',
              item3: 'Recuperación rápida'
            },
            service5: {
              title: 'Seguridad Gestionada',
              description: 'Administración de antivirus y firewall.',
              item1: 'Protección contra malware',
              item2: 'Firewall empresarial',
              item3: 'Políticas de seguridad'
            }
          },
          plan: {
            title: 'Plan Anual',
            price: 'Desde 300€/año',
            period: 'Precio adaptado a tu empresa',
            feature1: 'Auditoría inicial completa',
            feature2: 'Mantenimiento preventivo mensual',
            feature3: 'Soporte técnico prioritario 24/7',
            feature4: 'Gestión de copias de seguridad',
            feature5: 'Seguridad gestionada',
            feature6: 'Consultoría tecnológica'
          },
          finalCta: {
            title: '¿Quieres optimizar tu empresa?',
            description: 'Déjanos ser tu departamento de IT en San Javier.',
            whatsapp: 'Solicitar Información',
            pricing: 'Ver Planes'
          }
        },
        courses: {
          category: 'Formación IA',
          title: 'Cursos de Inteligencia Artificial Murcia',
          subtitle: 'Aprende a usar la IA para potenciar tu negocio o carrera.',
          intro: {
            title: 'Desbloquea el Poder de la IA',
            p1: 'La Inteligencia Artificial está transformando el mundo laboral.',
            p2: 'Nuestros cursos están diseñados para darte las herramientas prácticas que necesitas.'
          },
          modules: {
            title: 'Contenido del Curso',
            module1: {
              title: 'Introducción a la IA Generativa',
              description: '¿Qué es y cómo funciona la inteligencia artificial?',
              duration: '2 horas',
              level: 'Básico'
            },
            module2: {
              title: 'ChatGPT y Herramientas de Texto',
              description: 'Aprende a usar ChatGPT para mejorar tu productividad.',
              duration: '3 horas',
              level: 'Intermedio'
            },
            module3: {
              title: 'Generación de Imágenes con IA',
              description: 'Midjourney, DALL-E y otras herramientas visuales.',
              duration: '2 horas',
              level: 'Intermedio'
            },
            module4: {
              title: 'IA para Empresas',
              description: 'Aplicaciones prácticas para marketing, ventas y gestión.',
              duration: '4 horas',
              level: 'Avanzado'
            },
            module5: {
              title: 'Automatización con IA',
              description: 'Optimiza procesos y ahorra tiempo con automatización.',
              duration: '3 horas',
              level: 'Avanzado'
            }
          },
          who: {
            title: '¿Para quién es este curso?',
            target1: 'Empresarios que quieren optimizar su negocio',
            target2: 'Profesionales que buscan mejorar su productividad',
            target3: 'Estudiantes interesados en nuevas tecnologías',
            target4: 'Autónomos que quieren automatizar tareas',
            target5: 'Cualquier persona curiosa por aprender IA'
          },
          benefits: {
            title: 'Beneficios',
            benefit1: 'Aprende a tu ritmo',
            benefit2: 'Contenido 100% práctico',
            benefit3: 'Soporte post-curso',
            benefit4: 'Certificado de finalización',
            benefit5: 'Acceso a comunidad privada'
          },
          tools: {
            title: 'Herramientas que Aprenderás',
            tool1: {
              name: 'ChatGPT',
              description: 'Generación de texto y asistente virtual'
            },
            tool2: {
              name: 'Midjourney',
              description: 'Creación de imágenes con IA'
            },
            tool3: {
              name: 'Claude',
              description: 'Análisis y escritura avanzada'
            },
            tool4: {
              name: 'Copilot',
              description: 'Asistente de Microsoft'
            },
            tool5: {
              name: 'Gemini',
              description: 'IA de Google'
            },
            tool6: {
              name: 'Make/Zapier',
              description: 'Automatización de procesos'
            }
          },
          format: {
            title: 'Modalidades',
            option1: {
              title: 'Curso Individual',
              description: 'Clases personalizadas adaptadas a tus necesidades.'
            },
            option2: {
              title: 'Curso Grupal',
              description: 'Aprende junto a otros profesionales.'
            },
            option3: {
              title: 'Formación Empresarial',
              description: 'Curso in-company para tu equipo.'
            }
          },
          finalCta: {
            title: '¿Listo para dar el salto a la IA?',
            description: 'No te quedes atrás. Impulsa tu carrera o negocio.',
            whatsapp: 'Información sobre Cursos',
            contact: 'Ver Precios'
          }
        }
      }
    },
    en: {
      nav: {
        home: 'Home',
        services: 'Services',
        about: 'About Us',
        pricing: 'Pricing',
        contact: 'Contact'
      },
      hero: {
        subtitle: 'La Manga del Mar Menor · Cartagena · San Javier',
        title: 'Home & Business IT Solutions',
        description: 'Professional home IT technical service with over 20 years of experience and more than 5000 interventions. PC repair, virus removal, business maintenance and artificial intelligence courses. Available 24/7 in La Manga del Mar Menor, Cartagena and San Javier.',
        cta: 'Contact via WhatsApp',
        phone: 'Call Now',
        available: 'Available 24/7',
        experience: 'years of experience',
        features: {
          fast: 'Fast Service',
          fastDesc: 'Immediate home response in La Manga, Cartagena and San Javier',
          warranty: 'Full Warranty',
          warrantyDesc: 'All our services include satisfaction guarantee',
          professional: 'Certified Professional',
          professionalDesc: 'Over 20 years of experience and 5000+ satisfied customers'
        },
        schedule: {
          title: 'Service Hours',
          weekdays: 'Monday - Friday',
          weekdaysHours: '8:00 AM - 10:00 PM',
          saturday: 'Saturday',
          saturdayHours: '9:00 AM - 8:00 PM',
          sunday: 'Sunday',
          sundayHours: '10:00 AM - 6:00 PM',
          emergency: '24/7 Emergencies'
        }
      },
      services: {
        title: 'Our Services',
        subtitle: 'Complete solutions for all your IT needs in La Manga, Cartagena and San Javier',
        items: {
          repair: {
            title: 'PC and Laptop Repair',
            description: 'Hardware and software diagnosis and troubleshooting at home in La Manga del Mar Menor.'
          },
          virus: {
            title: 'Virus Removal',
            description: 'Complete malware and virus cleaning and system protection in Cartagena.'
          },
          maintenance: {
            title: 'Business Maintenance',
            description: 'Preventive and corrective maintenance plans for businesses in San Javier.'
          },
          installation: {
            title: 'Windows Installation',
            description: 'Professional installation and configuration of operating systems.'
          },
          courses: {
            title: 'AI Courses',
            description: 'Artificial intelligence training for individuals and companies in Murcia.'
          },
          support: {
            title: 'Data Recovery',
            description: 'Specialized lost data recovery services.'
          }
        },
        cta: {
          title: 'Need help with your device?',
          description: 'We are available 24/7 in La Manga, Cartagena and San Javier to solve any IT problem',
          button: 'Contact Now'
        }
      },
      about: {
        title: 'About BertoProduction',
        subtitle: '360° Web & IT Agency',
        description: 'BertoProduction is your 360-degree web and IT services agency in the world of technology. With over 20 years of experience, we offer complete solutions ranging from PC maintenance for businesses and individuals, to professional website creation, social media management (Social Media Manager), artificial intelligence implementation and autonomous agents development. We specialize in transforming our clients\' digital presence, combining traditional technical services with the latest innovations in AI and automation. We operate mainly in La Manga del Mar Menor, Cartagena and San Javier, providing 24/7 support to ensure your business never stops.',
        features: {
          experience: 'Years of Experience',
          availability: 'Availability',
          warranty: 'Satisfaction'
        },
        areas: {
          title: 'Service Areas',
          lamanga: 'La Manga',
          lamangatext: 'Mar Menor',
          cartagena: 'Cartagena',
          cartagenatext: 'Port',
          sanjavier: 'San Javier',
          sanjaviertext: 'Airport'
        }
      },
      pricing: {
        title: 'Plans and Pricing',
        subtitle: 'Customized solutions for every need, from one-time repairs to complete business support and AI training.',
        plans: {
          basic: {
            title: 'Essential Support',
            price: 'From €40',
            description: 'Ideal for one-time repairs and common problems.',
            features: [
              'Hardware/software diagnosis and repair',
              'Virus and malware removal',
              'System optimization',
              'Remote or home support'
            ],
            buttonText: 'Request Support'
          },
          business: {
            title: 'Annual Maintenance',
            price: 'From €300/year',
            popular: 'Most Popular',
            description: 'Comprehensive service for businesses seeking peace of mind and efficiency.',
            features: [
              'Everything in Essential plan',
              'Monthly preventive maintenance',
              'Priority 24/7 support',
              'IT consulting and security'
            ],
            buttonText: 'Hire Plan'
          },
          courses: {
            title: 'AI Courses',
            price: 'From €99',
            description: 'Learn to use AI to boost your business or career.',
            features: [
              'Personalized and group courses',
              'AI tools training',
              'Practical business applications',
              'Post-course support'
            ],
            buttonText: 'Enroll Now'
          }
        }
      },
      contact: {
        title: 'Contact',
        description: 'Have any questions or need assistance? Contact us.',
        phone: 'Phone',
        whatsapp: 'WhatsApp',
        email: 'Email',
        form: {
          name: 'Name',
          email: 'Email',
          message: 'Message',
          send: 'Send Message',
          success: 'Message sent successfully!',
          error: 'There was an error sending the message.'
        }
      },
      footer: {
        description: 'BertoProduction - Web and IT agency specialized in complete digital solutions for businesses and individuals in La Manga del Mar Menor, Cartagena and San Javier.',
        servicesTitle: 'Services',
        linksTitle: 'Quick Links',
        legalTitle: 'Legal',
        privacy: 'Privacy Policy',
        cookies: 'Cookie Policy',
        rights: 'All rights reserved.'
      },
      cookies: {
        title: 'Cookie Usage',
        description: 'We use essential cookies for site functionality and analytical cookies to improve your experience. You can customize your preferences at any time.',
        acceptAll: 'Accept All',
        rejectAll: 'Reject All',
        customize: 'Customize',
        readMore: 'Read Cookie Policy',
        settings: {
          title: 'Cookie Settings',
          required: 'Required',
          save: 'Save Preferences',
          necessary: {
            title: 'Necessary Cookies',
            description: 'Essential for the basic functioning of the website. Cannot be disabled.'
          },
          analytics: {
            title: 'Analytics Cookies',
            description: 'Help us understand how visitors interact with the website by collecting information anonymously.'
          }
        }
      },
      cookieBanner: {
        message: 'We use cookies to improve your experience. By continuing to browse, you accept our use of cookies.',
        accept: 'Accept'
      },
      privacy: {
        title: 'Privacy Policy',
        lastUpdated: 'Last updated: January 2024',
        intro: 'At BertoProduction, we respect your privacy and are committed to protecting your personal data. This policy explains how we collect, use and protect your information.',
        controller: {
          title: 'Data Controller',
          company: 'Company:',
          nif: 'Tax ID:',
          address: 'Address:',
          email: 'Email:',
          phone: 'Phone:'
        },
        collection: {
          title: 'Data We Collect',
          intro: 'We collect the following data when you use our services:',
          items: {
            name: 'Name and surname',
            email: 'Email address',
            phone: 'Phone number',
            service: 'Information about the requested service',
            message: 'Messages and communications'
          }
        },
        purpose: {
          title: 'Purpose of Processing',
          items: {
            respond: 'Respond to your inquiries and service requests',
            provide: 'Provide contracted services',
            improve: 'Improve our services and user experience',
            comply: 'Comply with legal obligations'
          }
        },
        legal: {
          title: 'Legal Basis',
          description: 'The processing of your data is based on your consent and the execution of the service contract.'
        },
        retention: {
          title: 'Data Retention',
          description: 'We will retain your data for the time necessary to fulfill the purposes described and applicable legal obligations.'
        },
        cookies: {
          title: 'Use of Cookies',
          description: 'We use cookies to improve your experience on our website:',
          necessary: {
            title: 'Necessary Cookies',
            description: 'Essential for the functioning of the website.'
          },
          analytics: {
            title: 'Analytics Cookies (Google Analytics)',
            description: 'Help us understand how users interact with our site.'
          }
        },
        rights: {
          title: 'Your Rights',
          intro: 'You have the right to:',
          items: {
            access: {
              title: 'Access:',
              description: 'Request access to your personal data.'
            },
            rectification: {
              title: 'Rectification:',
              description: 'Correct inaccurate or incomplete data.'
            },
            erasure: {
              title: 'Erasure:',
              description: 'Request the deletion of your data.'
            },
            restriction: {
              title: 'Restriction:',
              description: 'Limit the processing of your data.'
            },
            portability: {
              title: 'Portability:',
              description: 'Receive your data in a structured format.'
            },
            objection: {
              title: 'Objection:',
              description: 'Object to the processing of your data.'
            }
          },
          exercise: 'To exercise these rights, contact us through the means provided.'
        },
        security: {
          title: 'Security',
          description: 'We implement appropriate technical and organizational measures to protect your data against unauthorized access, loss or destruction.'
        },
        contact: {
          title: 'Contact',
          description: 'If you have questions about this privacy policy, contact us:',
          email: 'Send Email',
          phone: 'Call'
        }
      },
      articlesBanner: {
        title: 'Articles of Interest',
        subtitle: 'Discover more about our specialized services and how we can help you.',
        readMore: 'Read more',
        articles: {
          repair: {
            title: 'Complete PC Repair Guide',
            description: 'Learn about the most common problems and our solutions.'
          },
          virus: {
            title: 'How to Remove Viruses and Protect Your Device',
            description: 'Tips and services to keep your PC safe.'
          },
          maintenance: {
            title: 'IT Maintenance for Businesses',
            description: 'The importance of a preventive plan for your business.'
          },
          courses: {
            title: 'Get Started with Artificial Intelligence',
            description: 'Discover our courses and how AI can transform your work.'
          }
        }
      },
      articles: {
        readTime: '5 min read',
        updated: 'Updated 2024',
        cta: {
          urgent: 'Need urgent help?',
          available: 'Available 24/7',
          call: 'Call',
          virus: 'Virus on your PC?',
          immediate: 'Immediate assistance',
          business: 'Business Maintenance',
          plans: 'Custom plans',
          courses: 'AI Courses',
          learn: 'Learn now'
        },
        repair: {
          category: 'PC Repair',
          title: 'PC Repair La Manga del Mar Menor',
          subtitle: 'Professional PC and laptop repair service in La Manga del Mar Menor.',
          intro: {
            title: 'Quick Diagnosis and Solution for Your Computer',
            p1: 'A slow or broken computer can be a major inconvenience. We offer a fast and effective repair service in La Manga del Mar Menor so you can regain your productivity as soon as possible.',
            p2: 'With over 20 years of experience, we diagnose and solve from the simplest to the most complex problems.'
          },
          problems: {
            title: 'Common Problems We Solve',
            problem1: {
              title: 'Computer won\'t turn on',
              description: 'Problems with power supply, motherboard or internal components.'
            },
            problem2: {
              title: 'Slow system',
              description: 'Operating system optimization, malware cleaning and performance improvement.'
            },
            problem3: {
              title: 'Blue screens',
              description: 'Diagnosis of critical system errors and hardware conflict resolution.'
            },
            problem4: {
              title: 'Overheating',
              description: 'Fan cleaning, thermal paste replacement and cooling improvement.'
            },
            problem5: {
              title: 'Hardware failures',
              description: 'Replacement of hard drives, RAM, graphics cards and other components.'
            }
          },
          process: {
            title: 'Our Repair Process',
            step1: {
              title: 'Initial Contact',
              description: 'You contact us via WhatsApp or phone and explain your problem.'
            },
            step2: {
              title: 'Diagnosis',
              description: 'We perform a complete diagnosis to identify the cause of the failure.'
            },
            step3: {
              title: 'Quote',
              description: 'We offer you a fixed quote without commitment.'
            },
            step4: {
              title: 'Repair',
              description: 'We proceed with the repair using quality components.'
            }
          },
          why: {
            title: 'Why choose us?',
            reason1: 'Over 20 years of experience in PC repair',
            reason2: 'Home service in La Manga del Mar Menor',
            reason3: 'Quote without commitment',
            reason4: 'Warranty on all our repairs'
          },
          finalCta: {
            title: 'Does your computer need help?',
            description: 'Contact us now and get a fast and professional solution.',
            whatsapp: 'Contact via WhatsApp',
            contact: 'View Prices'
          }
        },
        virus: {
          category: 'Virus Removal',
          title: 'Virus Removal Cartagena',
          subtitle: 'Expert virus and malware removal service in Cartagena.',
          intro: {
            title: 'Restore Your Device\'s Security and Speed',
            p1: 'Viruses and malware not only slow down your computer, but also put your personal information at risk.',
            p2: 'Our virus removal service in Cartagena is designed to thoroughly clean your system and protect you against future threats.'
          },
          signs: {
            title: 'Signs your PC might be infected',
            sign1: 'Extreme slowness and unexpected crashes',
            sign2: 'Appearance of unwanted pop-ups',
            sign3: 'Programs that start on their own',
            sign4: 'Redirects to unknown websites',
            sign5: 'Fake antivirus messages',
            sign6: 'Files that disappear or cannot be opened'
          },
          types: {
            title: 'Types of Threats We Remove',
            type1: {
              title: 'Viruses and Trojans',
              description: 'Malicious programs that replicate and damage the system.'
            },
            type2: {
              title: 'Ransomware',
              description: 'Malware that encrypts your files and demands ransom.'
            },
            type3: {
              title: 'Spyware',
              description: 'Spy software that steals your personal information.'
            },
            type4: {
              title: 'Adware',
              description: 'Unwanted advertising that slows down your browser.'
            },
            type5: {
              title: 'Rootkits',
              description: 'Hidden threats difficult to detect.'
            }
          },
          service: {
            title: 'Our Cleaning Method',
            step1: {
              title: 'Deep Analysis',
              description: 'We scan the entire system for threats.'
            },
            step2: {
              title: 'Safe Removal',
              description: 'We remove all malware without damaging your files.'
            },
            step3: {
              title: 'Optimization',
              description: 'We optimize performance and update security.'
            },
            step4: {
              title: 'Protection',
              description: 'We install and configure antivirus protection.'
            }
          },
          prevention: {
            title: 'Prevention Tips',
            tip1: 'Keep your antivirus updated',
            tip2: 'Don\'t open emails from unknown senders',
            tip3: 'Download software only from official sources',
            tip4: 'Backup regularly',
            tip5: 'Keep your operating system updated'
          },
          finalCta: {
            title: 'Suspect you have a virus?',
            description: 'Act now before it\'s too late. Protect your information.',
            whatsapp: 'Clean My PC Now',
            contact: 'More Information'
          }
        },
        maintenance: {
          category: 'Business Maintenance',
          title: 'IT Maintenance San Javier',
          subtitle: 'Maintenance service for businesses in San Javier.',
          intro: {
            title: 'The Peace of Mind of a Reliable IT System',
            p1: 'In a business environment, any IT failure can mean loss of time and money.',
            p2: 'Our maintenance service is designed to prevent problems before they occur.'
          },
          benefits: {
            title: 'Maintenance Benefits',
            benefit1: {
              title: 'Reduced breakdowns',
              description: 'Less downtime and greater productivity.'
            },
            benefit2: {
              title: 'Better performance',
              description: 'Optimized and updated equipment.'
            },
            benefit3: {
              title: 'Priority support',
              description: 'Fast response to any incident.'
            },
            benefit4: {
              title: 'Enhanced security',
              description: 'Protection against cyber attacks and data loss.'
            },
            benefit5: {
              title: 'Consulting',
              description: 'Technology consulting to optimize resources.'
            },
            benefit6: {
              title: 'Predictable costs',
              description: 'Annual plan with fixed price.'
            }
          },
          services: {
            title: 'Included Services',
            service1: {
              title: 'Initial Audit',
              description: 'We evaluate the state of your IT infrastructure.',
              item1: 'Equipment and network analysis',
              item2: 'Vulnerability identification',
              item3: 'Personalized improvement plan'
            },
            service2: {
              title: 'Preventive Maintenance',
              description: 'Regular reviews to optimize the system.',
              item1: 'Hardware cleaning',
              item2: 'Software updates',
              item3: 'Performance optimization'
            },
            service3: {
              title: 'Technical Support',
              description: 'Remote and telephone assistance.',
              item1: 'Incident resolution',
              item2: 'Technical advice',
              item3: '24/7 availability'
            },
            service4: {
              title: 'Backups',
              description: 'Data protection with automated backups.',
              item1: 'Automatic daily backups',
              item2: 'Secure storage',
              item3: 'Fast recovery'
            },
            service5: {
              title: 'Managed Security',
              description: 'Antivirus and firewall management.',
              item1: 'Malware protection',
              item2: 'Business firewall',
              item3: 'Security policies'
            }
          },
          plan: {
            title: 'Annual Plan',
            price: 'From €300/year',
            period: 'Price adapted to your company',
            feature1: 'Complete initial audit',
            feature2: 'Monthly preventive maintenance',
            feature3: 'Priority technical support 24/7',
            feature4: 'Backup management',
            feature5: 'Managed security',
            feature6: 'Technology consulting'
          },
          finalCta: {
            title: 'Want to optimize your business?',
            description: 'Let us be your IT department in San Javier.',
            whatsapp: 'Request Information',
            pricing: 'View Plans'
          }
        },
        courses: {
          category: 'AI Training',
          title: 'Artificial Intelligence Courses Murcia',
          subtitle: 'Learn to use AI to boost your business or career.',
          intro: {
            title: 'Unlock the Power of AI',
            p1: 'Artificial Intelligence is transforming the work world.',
            p2: 'Our courses are designed to give you the practical tools you need.'
          },
          modules: {
            title: 'Course Content',
            module1: {
              title: 'Introduction to Generative AI',
              description: 'What is artificial intelligence and how does it work?',
              duration: '2 hours',
              level: 'Basic'
            },
            module2: {
              title: 'ChatGPT and Text Tools',
              description: 'Learn to use ChatGPT to improve your productivity.',
              duration: '3 hours',
              level: 'Intermediate'
            },
            module3: {
              title: 'AI Image Generation',
              description: 'Midjourney, DALL-E and other visual tools.',
              duration: '2 hours',
              level: 'Intermediate'
            },
            module4: {
              title: 'AI for Business',
              description: 'Practical applications for marketing, sales and management.',
              duration: '4 hours',
              level: 'Advanced'
            },
            module5: {
              title: 'Automation with AI',
              description: 'Optimize processes and save time with automation.',
              duration: '3 hours',
              level: 'Advanced'
            }
          },
          who: {
            title: 'Who is this course for?',
            target1: 'Entrepreneurs who want to optimize their business',
            target2: 'Professionals seeking to improve their productivity',
            target3: 'Students interested in new technologies',
            target4: 'Self-employed who want to automate tasks',
            target5: 'Anyone curious to learn AI'
          },
          benefits: {
            title: 'Benefits',
            benefit1: 'Learn at your own pace',
            benefit2: '100% practical content',
            benefit3: 'Post-course support',
            benefit4: 'Completion certificate',
            benefit5: 'Access to private community'
          },
          tools: {
            title: 'Tools You\'ll Learn',
            tool1: {
              name: 'ChatGPT',
              description: 'Text generation and virtual assistant'
            },
            tool2: {
              name: 'Midjourney',
              description: 'AI image creation'
            },
            tool3: {
              name: 'Claude',
              description: 'Advanced analysis and writing'
            },
            tool4: {
              name: 'Copilot',
              description: 'Microsoft assistant'
            },
            tool5: {
              name: 'Gemini',
              description: 'Google AI'
            },
            tool6: {
              name: 'Make/Zapier',
              description: 'Process automation'
            }
          },
          format: {
            title: 'Modalities',
            option1: {
              title: 'Individual Course',
              description: 'Personalized classes adapted to your needs.'
            },
            option2: {
              title: 'Group Course',
              description: 'Learn alongside other professionals.'
            },
            option3: {
              title: 'Corporate Training',
              description: 'In-company course for your team.'
            }
          },
          finalCta: {
            title: 'Ready to jump into AI?',
            description: 'Don\'t get left behind. Boost your career or business.',
            whatsapp: 'Course Information',
            contact: 'View Prices'
          }
        }
      }
    },
    it: {
      nav: {
        home: 'Home',
        services: 'Servizi',
        about: 'Chi Siamo',
        pricing: 'Prezzi',
        contact: 'Contatti'
      },
      hero: {
        subtitle: 'La Manga del Mar Menor · Cartagena · San Javier',
        title: 'Soluzioni Informatiche a Domicilio e per Aziende',
        description: 'Servizio tecnico informatico professionale a domicilio con oltre 20 anni di esperienza e più di 5000 interventi realizzati. Riparazione PC, rimozione virus, manutenzione aziendale e corsi di intelligenza artificiale. Disponibile 24/7 a La Manga del Mar Menor, Cartagena e San Javier.',
        cta: 'Contatta via WhatsApp',
        phone: 'Chiama Ora',
        available: 'Disponibile 24/7',
        experience: 'anni di esperienza',
        features: {
          fast: 'Servizio Rapido',
          fastDesc: 'Risposta immediata a domicilio a La Manga, Cartagena e San Javier',
          warranty: 'Garanzia Totale',
          warrantyDesc: 'Tutti i nostri servizi includono garanzia di soddisfazione',
          professional: 'Professionista Certificato',
          professionalDesc: 'Oltre 20 anni di esperienza e 5000+ clienti soddisfatti'
        },
        schedule: {
          title: 'Orari di Servizio',
          weekdays: 'Lunedì - Venerdì',
          weekdaysHours: '8:00 - 22:00',
          saturday: 'Sabato',
          saturdayHours: '9:00 - 20:00',
          sunday: 'Domenica',
          sundayHours: '10:00 - 18:00',
          emergency: 'Emergenze 24/7'
        }
      },
      services: {
        title: 'I Nostri Servizi',
        subtitle: 'Soluzioni complete per tutte le tue esigenze informatiche a La Manga, Cartagena e San Javier',
        items: {
          repair: {
            title: 'Riparazione PC e Portatili',
            description: 'Diagnosi e risoluzione problemi hardware e software a domicilio a La Manga del Mar Menor.'
          },
          virus: {
            title: 'Rimozione Virus',
            description: 'Pulizia completa malware, virus e protezione del sistema a Cartagena.'
          },
          maintenance: {
            title: 'Manutenzione Aziende',
            description: 'Piani di manutenzione preventiva e correttiva per aziende a San Javier.'
          },
          installation: {
            title: 'Installazione Windows',
            description: 'Installazione e configurazione professionale di sistemi operativi.'
          },
          courses: {
            title: 'Corsi di IA',
            description: 'Formazione in intelligenza artificiale per privati e aziende a Murcia.'
          },
          support: {
            title: 'Recupero Dati',
            description: 'Servizi specializzati di recupero dati persi.'
          }
        },
        cta: {
          title: 'Hai bisogno di aiuto con il tuo dispositivo?',
          description: 'Siamo disponibili 24/7 a La Manga, Cartagena e San Javier per risolvere qualsiasi problema informatico',
          button: 'Contatta Ora'
        }
      },
      about: {
        title: 'Su BertoProduction',
        subtitle: 'Agenzia Web e Informatica 360°',
        description: 'BertoProduction è la tua agenzia web e informatica di servizi a 360 gradi nel mondo della tecnologia. Con oltre 20 anni di esperienza, offriamo soluzioni complete che spaziano dalla manutenzione PC per aziende e privati, alla creazione di siti web professionali, gestione social media (Social Media Manager), implementazione di intelligenza artificiale e sviluppo di agenti autonomi. Ci specializziamo nel trasformare la presenza digitale dei nostri clienti, combinando servizi tecnici tradizionali con le ultime innovazioni in IA e automazione. Operiamo principalmente a La Manga del Mar Menor, Cartagena e San Javier, fornendo supporto 24/7 per garantire che il tuo business non si fermi mai.',
        features: {
          experience: 'Anni di Esperienza',
          availability: 'Disponibilità',
          warranty: 'Soddisfazione'
        },
        areas: {
          title: 'Zone di Servizio',
          lamanga: 'La Manga',
          lamangatext: 'Mar Menor',
          cartagena: 'Cartagena',
          cartagenatext: 'Porto',
          sanjavier: 'San Javier',
          sanjaviertext: 'Aeroporto'
        }
      },
      pricing: {
        title: 'Piani e Prezzi',
        subtitle: 'Soluzioni su misura per ogni esigenza, da riparazioni puntuali a supporto aziendale completo e formazione in IA.',
        plans: {
          basic: {
            title: 'Supporto Essenziale',
            price: 'Da 40€',
            description: 'Ideale per riparazioni puntuali e problemi comuni.',
            features: [
              'Diagnosi e riparazione hardware/software',
              'Rimozione virus e malware',
              'Ottimizzazione del sistema',
              'Supporto remoto o a domicilio'
            ],
            buttonText: 'Richiedi Supporto'
          },
          business: {
            title: 'Manutenzione Annuale',
            price: 'Da 300€/anno',
            popular: 'Più Popolare',
            description: 'Servizio integrale per aziende che cercano tranquillità ed efficienza.',
            features: [
              'Tutto il piano Essenziale',
              'Manutenzione preventiva mensile',
              'Supporto prioritario 24/7',
              'Consulenza e sicurezza informatica'
            ],
            buttonText: 'Attiva Piano'
          },
          courses: {
            title: 'Corsi di IA',
            price: 'Da 99€',
            description: 'Impara a utilizzare l\'IA per potenziare il tuo business o carriera.',
            features: [
              'Corsi personalizzati e di gruppo',
              'Formazione su strumenti di IA',
              'Applicazioni pratiche per aziende',
              'Supporto post-corso'
            ],
            buttonText: 'Iscriviti Ora'
          }
        }
      },
      contact: {
        title: 'Contatti',
        description: 'Hai domande o hai bisogno di assistenza? Contattaci.',
        phone: 'Telefono',
        whatsapp: 'WhatsApp',
        email: 'Email',
        form: {
          name: 'Nome',
          email: 'Email',
          message: 'Messaggio',
          send: 'Invia Messaggio',
          success: 'Messaggio inviato con successo!',
          error: 'Si è verificato un errore nell\'invio del messaggio.'
        }
      },
      footer: {
        description: 'BertoProduction - Agenzia web e informatica specializzata in soluzioni digitali complete per aziende e privati a La Manga del Mar Menor, Cartagena e San Javier.',
        servicesTitle: 'Servizi',
        linksTitle: 'Link Rapidi',
        legalTitle: 'Legale',
        privacy: 'Privacy Policy',
        cookies: 'Cookie Policy',
        rights: 'Tutti i diritti riservati.'
      },
      cookies: {
        title: 'Utilizzo dei Cookie',
        description: 'Utilizziamo cookie essenziali per il funzionamento del sito e cookie analitici per migliorare la tua esperienza. Puoi personalizzare le tue preferenze in qualsiasi momento.',
        acceptAll: 'Accetta Tutto',
        rejectAll: 'Rifiuta Tutto',
        customize: 'Personalizza',
        readMore: 'Leggi Cookie Policy',
        settings: {
          title: 'Impostazioni Cookie',
          required: 'Richiesto',
          save: 'Salva Preferenze',
          necessary: {
            title: 'Cookie Necessari',
            description: 'Essenziali per il funzionamento base del sito web. Non possono essere disattivati.'
          },
          analytics: {
            title: 'Cookie Analitici',
            description: 'Ci aiutano a capire come i visitatori interagiscono con il sito raccogliendo informazioni in forma anonima.'
          }
        }
      },
      cookieBanner: {
        message: 'Utilizziamo cookie per migliorare la tua esperienza. Continuando a navigare, accetti il nostro uso dei cookie.',
        accept: 'Accetta'
      },
      privacy: {
        title: 'Privacy Policy',
        lastUpdated: 'Ultimo aggiornamento: Gennaio 2024',
        intro: 'In BertoProduction, rispettiamo la tua privacy e ci impegniamo a proteggere i tuoi dati personali. Questa politica spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.',
        controller: {
          title: 'Responsabile del Trattamento',
          company: 'Azienda:',
          nif: 'Partita IVA:',
          address: 'Indirizzo:',
          email: 'Email:',
          phone: 'Telefono:'
        },
        collection: {
          title: 'Dati che Raccogliamo',
          intro: 'Raccogliamo i seguenti dati quando utilizzi i nostri servizi:',
          items: {
            name: 'Nome e cognome',
            email: 'Indirizzo email',
            phone: 'Numero di telefono',
            service: 'Informazioni sul servizio richiesto',
            message: 'Messaggi e comunicazioni'
          }
        },
        purpose: {
          title: 'Finalità del Trattamento',
          items: {
            respond: 'Rispondere alle tue richieste e richieste di servizio',
            provide: 'Fornire i servizi contrattati',
            improve: 'Migliorare i nostri servizi e l\'esperienza utente',
            comply: 'Adempiere agli obblighi legali'
          }
        },
        legal: {
          title: 'Base Legale',
          description: 'Il trattamento dei tuoi dati si basa sul tuo consenso e sull\'esecuzione del contratto di servizi.'
        },
        retention: {
          title: 'Conservazione dei Dati',
          description: 'Conserveremo i tuoi dati per il tempo necessario a soddisfare le finalità descritte e gli obblighi legali applicabili.'
        },
        cookies: {
          title: 'Uso dei Cookie',
          description: 'Utilizziamo cookie per migliorare la tua esperienza sul nostro sito web:',
          necessary: {
            title: 'Cookie Necessari',
            description: 'Essenziali per il funzionamento del sito web.'
          },
          analytics: {
            title: 'Cookie Analitici (Google Analytics)',
            description: 'Ci aiutano a capire come gli utenti interagiscono con il nostro sito.'
          }
        },
        rights: {
          title: 'I Tuoi Diritti',
          intro: 'Hai il diritto di:',
          items: {
            access: {
              title: 'Accesso:',
              description: 'Richiedere l\'accesso ai tuoi dati personali.'
            },
            rectification: {
              title: 'Rettifica:',
              description: 'Correggere dati inesatti o incompleti.'
            },
            erasure: {
              title: 'Cancellazione:',
              description: 'Richiedere la cancellazione dei tuoi dati.'
            },
            restriction: {
              title: 'Limitazione:',
              description: 'Limitare il trattamento dei tuoi dati.'
            },
            portability: {
              title: 'Portabilità:',
              description: 'Ricevere i tuoi dati in formato strutturato.'
            },
            objection: {
              title: 'Opposizione:',
              description: 'Opporti al trattamento dei tuoi dati.'
            }
          },
          exercise: 'Per esercitare questi diritti, contattaci tramite i mezzi forniti.'
        },
        security: {
          title: 'Sicurezza',
          description: 'Implementiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati da accesso non autorizzato, perdita o distruzione.'
        },
        contact: {
          title: 'Contatto',
          description: 'Se hai domande su questa privacy policy, contattaci:',
          email: 'Invia Email',
          phone: 'Chiama'
        }
      },
      articlesBanner: {
        title: 'Articoli di Interesse',
        subtitle: 'Scopri di più sui nostri servizi specializzati e come possiamo aiutarti.',
        readMore: 'Leggi di più',
        articles: {
          repair: {
            title: 'Guida Completa alla Riparazione PC',
            description: 'Scopri i problemi più comuni e le nostre soluzioni.'
          },
          virus: {
            title: 'Come Rimuovere Virus e Proteggere il Tuo Dispositivo',
            description: 'Consigli e servizi per mantenere il tuo PC sicuro.'
          },
          maintenance: {
            title: 'Manutenzione Informatica per Aziende',
            description: 'L\'importanza di un piano preventivo per il tuo business.'
          },
          courses: {
            title: 'Inizia con l\'Intelligenza Artificiale',
            description: 'Scopri i nostri corsi e come l\'IA può trasformare il tuo lavoro.'
          }
        }
      },
      articles: {
        readTime: '5 min di lettura',
        updated: 'Aggiornato 2024',
        cta: {
          urgent: 'Hai bisogno di aiuto urgente?',
          available: 'Disponibile 24/7',
          call: 'Chiama',
          virus: 'Virus sul tuo PC?',
          immediate: 'Assistenza immediata',
          business: 'Manutenzione Aziendale',
          plans: 'Piani personalizzati',
          courses: 'Corsi di IA',
          learn: 'Impara ora'
        },
        repair: {
          category: 'Riparazione PC',
          title: 'Riparazione PC La Manga del Mar Menor',
          subtitle: 'Servizio professionale di riparazione PC e portatili a La Manga del Mar Menor.',
          intro: {
            title: 'Diagnosi e Soluzione Rapida per il Tuo Computer',
            p1: 'Un computer lento o guasto può essere un grande inconveniente. Offriamo un servizio di riparazione rapido ed efficace a La Manga del Mar Menor per recuperare la tua produttività il prima possibile.',
            p2: 'Con oltre 20 anni di esperienza, diagnostichiamo e risolviamo dai problemi più semplici ai più complessi.'
          },
          problems: {
            title: 'Problemi Comuni che Risolviamo',
            problem1: {
              title: 'Il computer non si accende',
              description: 'Problemi con alimentatore, scheda madre o componenti interni.'
            },
            problem2: {
              title: 'Sistema lento',
              description: 'Ottimizzazione del sistema operativo, pulizia malware e miglioramento prestazioni.'
            },
            problem3: {
              title: 'Schermate blu',
              description: 'Diagnosi errori critici del sistema e risoluzione conflitti hardware.'
            },
            problem4: {
              title: 'Surriscaldamento',
              description: 'Pulizia ventole, cambio pasta termica e miglioramento raffreddamento.'
            },
            problem5: {
              title: 'Guasti hardware',
              description: 'Sostituzione hard disk, RAM, schede grafiche e altri componenti.'
            }
          },
          process: {
            title: 'Il Nostro Processo di Riparazione',
            step1: {
              title: 'Contatto Iniziale',
              description: 'Ci contatti via WhatsApp o telefono e ci spieghi il problema.'
            },
            step2: {
              title: 'Diagnosi',
              description: 'Effettuiamo una diagnosi completa per identificare la causa del guasto.'
            },
            step3: {
              title: 'Preventivo',
              description: 'Ti offriamo un preventivo chiuso e senza impegno.'
            },
            step4: {
              title: 'Riparazione',
              description: 'Procediamo con la riparazione usando componenti di qualità.'
            }
          },
          why: {
            title: 'Perché sceglierci?',
            reason1: 'Oltre 20 anni di esperienza nella riparazione PC',
            reason2: 'Servizio a domicilio a La Manga del Mar Menor',
            reason3: 'Preventivo senza impegno',
            reason4: 'Garanzia su tutte le nostre riparazioni'
          },
          finalCta: {
            title: 'Il tuo computer ha bisogno di aiuto?',
            description: 'Contattaci ora e ottieni una soluzione rapida e professionale.',
            whatsapp: 'Contatta via WhatsApp',
            contact: 'Vedi Prezzi'
          }
        },
        virus: {
          category: 'Rimozione Virus',
          title: 'Rimozione Virus Cartagena',
          subtitle: 'Servizio esperto di rimozione virus e malware a Cartagena.',
          intro: {
            title: 'Recupera la Sicurezza e Velocità del Tuo Dispositivo',
            p1: 'I virus e il malware non solo rallentano il tuo computer, ma mettono anche a rischio le tue informazioni personali.',
            p2: 'Il nostro servizio di rimozione virus a Cartagena è progettato per pulire a fondo il tuo sistema e proteggerti contro future minacce.'
          },
          signs: {
            title: 'Segnali che il tuo PC potrebbe essere infetto',
            sign1: 'Lentezza estrema e blocchi imprevisti',
            sign2: 'Comparsa di finestre pop-up indesiderate',
            sign3: 'Programmi che si avviano da soli',
            sign4: 'Reindirizzamenti a pagine web sconosciute',
            sign5: 'Messaggi di antivirus falsi',
            sign6: 'File che scompaiono o non si possono aprire'
          },
          types: {
            title: 'Tipi di Minacce che Rimuoviamo',
            type1: {
              title: 'Virus e Trojan',
              description: 'Programmi maligni che si replicano e danneggiano il sistema.'
            },
            type2: {
              title: 'Ransomware',
              description: 'Malware che cripta i tuoi file e chiede riscatto.'
            },
            type3: {
              title: 'Spyware',
              description: 'Software spia che ruba le tue informazioni personali.'
            },
            type4: {
              title: 'Adware',
              description: 'Pubblicità indesiderata che rallenta il browser.'
            },
            type5: {
              title: 'Rootkit',
              description: 'Minacce nascoste difficili da rilevare.'
            }
          },
          service: {
            title: 'Il Nostro Metodo di Pulizia',
            step1: {
              title: 'Analisi Profonda',
              description: 'Scansione completa del sistema alla ricerca di minacce.'
            },
            step2: {
              title: 'Rimozione Sicura',
              description: 'Rimuoviamo tutto il malware senza danneggiare i tuoi file.'
            },
            step3: {
              title: 'Ottimizzazione',
              description: 'Ottimizziamo le prestazioni e aggiorniamo la sicurezza.'
            },
            step4: {
              title: 'Protezione',
              description: 'Installiamo e configuriamo la protezione antivirus.'
            }
          },
          prevention: {
            title: 'Consigli di Prevenzione',
            tip1: 'Mantieni il tuo antivirus aggiornato',
            tip2: 'Non aprire email da mittenti sconosciuti',
            tip3: 'Scarica software solo da fonti ufficiali',
            tip4: 'Esegui backup regolarmente',
            tip5: 'Mantieni il sistema operativo aggiornato'
          },
          finalCta: {
            title: 'Sospetti di avere un virus?',
            description: 'Agisci ora prima che sia troppo tardi. Proteggi le tue informazioni.',
            whatsapp: 'Pulisci il Mio PC Ora',
            contact: 'Più Informazioni'
          }
        },
        maintenance: {
          category: 'Manutenzione Aziendale',
          title: 'Manutenzione Informatica San Javier',
          subtitle: 'Servizio di manutenzione per aziende a San Javier.',
          intro: {
            title: 'La Tranquillità di un Sistema Informatico Affidabile',
            p1: 'In un ambiente aziendale, qualsiasi guasto informatico può significare perdite di tempo e denaro.',
            p2: 'Il nostro servizio di manutenzione è progettato per prevenire i problemi prima che si verifichino.'
          },
          benefits: {
            title: 'Benefici della Manutenzione',
            benefit1: {
              title: 'Riduzione guasti',
              description: 'Meno tempo di inattività e maggiore produttività.'
            },
            benefit2: {
              title: 'Migliori prestazioni',
              description: 'Dispositivi ottimizzati e aggiornati.'
            },
            benefit3: {
              title: 'Supporto prioritario',
              description: 'Risposta rapida a qualsiasi incidente.'
            },
            benefit4: {
              title: 'Sicurezza rafforzata',
              description: 'Protezione contro attacchi informatici e perdita dati.'
            },
            benefit5: {
              title: 'Consulenza',
              description: 'Consulenza tecnologica per ottimizzare risorse.'
            },
            benefit6: {
              title: 'Costi prevedibili',
              description: 'Piano annuale con prezzo fisso.'
            }
          },
          services: {
            title: 'Servizi Inclusi',
            service1: {
              title: 'Audit Iniziale',
              description: 'Valutiamo lo stato della tua infrastruttura informatica.',
              item1: 'Analisi dispositivi e rete',
              item2: 'Identificazione vulnerabilità',
              item3: 'Piano di miglioramento personalizzato'
            },
            service2: {
              title: 'Manutenzione Preventiva',
              description: 'Revisioni periodiche per ottimizzare il sistema.',
              item1: 'Pulizia hardware',
              item2: 'Aggiornamenti software',
              item3: 'Ottimizzazione prestazioni'
            },
            service3: {
              title: 'Supporto Tecnico',
              description: 'Assistenza remota e telefonica.',
              item1: 'Risoluzione incidenti',
              item2: 'Consulenza tecnica',
              item3: 'Disponibilità 24/7'
            },
            service4: {
              title: 'Backup',
              description: 'Protezione dati con backup automatizzati.',
              item1: 'Backup giornalieri automatici',
              item2: 'Archiviazione sicura',
              item3: 'Recupero rapido'
            },
            service5: {
              title: 'Sicurezza Gestita',
              description: 'Gestione antivirus e firewall.',
              item1: 'Protezione contro malware',
              item2: 'Firewall aziendale',
              item3: 'Politiche di sicurezza'
            }
          },
          plan: {
            title: 'Piano Annuale',
            price: 'Da 300€/anno',
            period: 'Prezzo adattato alla tua azienda',
            feature1: 'Audit iniziale completo',
            feature2: 'Manutenzione preventiva mensile',
            feature3: 'Supporto tecnico prioritario 24/7',
            feature4: 'Gestione backup',
            feature5: 'Sicurezza gestita',
            feature6: 'Consulenza tecnologica'
          },
          finalCta: {
            title: 'Vuoi ottimizzare la tua azienda?',
            description: 'Lascia che siamo il tuo reparto IT a San Javier.',
            whatsapp: 'Richiedi Informazioni',
            pricing: 'Vedi Piani'
          }
        },
        courses: {
          category: 'Formazione IA',
          title: 'Corsi di Intelligenza Artificiale Murcia',
          subtitle: 'Impara a usare l\'IA per potenziare il tuo business o carriera.',
          intro: {
            title: 'Sblocca il Potere dell\'IA',
            p1: 'L\'Intelligenza Artificiale sta trasformando il mondo del lavoro.',
            p2: 'I nostri corsi sono progettati per darti gli strumenti pratici di cui hai bisogno.'
          },
          modules: {
            title: 'Contenuto del Corso',
            module1: {
              title: 'Introduzione all\'IA Generativa',
              description: 'Cos\'è e come funziona l\'intelligenza artificiale?',
              duration: '2 ore',
              level: 'Base'
            },
            module2: {
              title: 'ChatGPT e Strumenti di Testo',
              description: 'Impara a usare ChatGPT per migliorare la tua produttività.',
              duration: '3 ore',
              level: 'Intermedio'
            },
            module3: {
              title: 'Generazione Immagini con IA',
              description: 'Midjourney, DALL-E e altri strumenti visuali.',
              duration: '2 ore',
              level: 'Intermedio'
            },
            module4: {
              title: 'IA per Aziende',
              description: 'Applicazioni pratiche per marketing, vendite e gestione.',
              duration: '4 ore',
              level: 'Avanzato'
            },
            module5: {
              title: 'Automazione con IA',
              description: 'Ottimizza processi e risparmia tempo con l\'automazione.',
              duration: '3 ore',
              level: 'Avanzato'
            }
          },
          who: {
            title: 'Per chi è questo corso?',
            target1: 'Imprenditori che vogliono ottimizzare il loro business',
            target2: 'Professionisti che cercano di migliorare la produttività',
            target3: 'Studenti interessati alle nuove tecnologie',
            target4: 'Autonomi che vogliono automatizzare compiti',
            target5: 'Chiunque sia curioso di imparare l\'IA'
          },
          benefits: {
            title: 'Benefici',
            benefit1: 'Impara al tuo ritmo',
            benefit2: 'Contenuto 100% pratico',
            benefit3: 'Supporto post-corso',
            benefit4: 'Certificato di completamento',
            benefit5: 'Accesso a comunità privata'
          },
          tools: {
            title: 'Strumenti che Imparerai',
            tool1: {
              name: 'ChatGPT',
              description: 'Generazione testo e assistente virtuale'
            },
            tool2: {
              name: 'Midjourney',
              description: 'Creazione immagini con IA'
            },
            tool3: {
              name: 'Claude',
              description: 'Analisi e scrittura avanzata'
            },
            tool4: {
              name: 'Copilot',
              description: 'Assistente Microsoft'
            },
            tool5: {
              name: 'Gemini',
              description: 'IA di Google'
            },
            tool6: {
              name: 'Make/Zapier',
              description: 'Automazione processi'
            }
          },
          format: {
            title: 'Modalità',
            option1: {
              title: 'Corso Individuale',
              description: 'Lezioni personalizzate adattate alle tue esigenze.'
            },
            option2: {
              title: 'Corso di Gruppo',
              description: 'Impara insieme ad altri professionisti.'
            },
            option3: {
              title: 'Formazione Aziendale',
              description: 'Corso in-company per il tuo team.'
            }
          },
          finalCta: {
            title: 'Pronto per il salto nell\'IA?',
            description: 'Non restare indietro. Potenzia la tua carriera o business.',
            whatsapp: 'Informazioni sui Corsi',
            contact: 'Vedi Prezzi'
          }
        }
      }
    }
  };

  const t = (key) => {
    return key.split('.').reduce((obj, k) => {
      return obj && obj[k];
    }, translations[language]);
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && ['es', 'en', 'it'].includes(savedLanguage)) {
      setLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (lang) => {
    if (['es', 'en', 'it'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};